/**
 * Sub1 Template
 * @category testApp
 */
class ClassfilterTempl {
    /**
     * Sub1 Templ
     * @param  {Object} _d={}
     */
    static getClassFilterTempl(_d={}) {
        const options = `<option value="" data-server-types="All">직업전체</option>` + _d.map(ClassfilterTempl.getClassOptionTempl).join('');
        return `
        ${options}
        `;
    }

    static getClassOptionTempl(_d){
        let serverType = '';
        for(let i=0;i<_d.serverTypes.length;i++){
            if(serverType === ''){
                serverType += _d.serverTypes[i];
            }
            else{
                serverType += ','+_d.serverTypes[i];
            }
        }
        return `
        <option value="${_d.id}" data-server-type="${serverType}">${_d.name}</option>
    	`;
    }

} // end of class

export default ClassfilterTempl;